/**
 * Shared error-code catalog for plan-limit responses.
 *
 * This module is imported by both `client.ts` (to tag `ApiResponse`) and
 * `generation.ts` (to re-export for UI code). Keep it import-free to avoid
 * cycles — in particular, client.ts imports `captureError` from sentry.ts,
 * and generation.ts imports ApiError from client.ts.
 */

export const PLAN_ERROR_CODES = {
  DAILY_QUOTA_EXCEEDED: 'DAILY_QUOTA_EXCEEDED',
  CONCURRENT_LIMIT_EXCEEDED: 'CONCURRENT_LIMIT_EXCEEDED',
  NO_SUBSCRIPTION: 'NO_SUBSCRIPTION',
  CREDIT_LIMIT_EXCEEDED: 'CREDIT_LIMIT_EXCEEDED',
  SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED',
} as const;

// Client paths gated by backend `requireQuota`. Mirrors the middleware mount
// points in the imagen backend:
//   src/routes/api/job.ts — start / run-step / inpaint / text-to-image
//   src/domains/posedraw/routes/model_generate.ts — /api/models/generate
//   src/domains/posedraw/routes/pose.ts — /api/pose/import-from-prompt
export const QUOTA_GATED_PATH_FRAGMENTS = [
  'api/job/start',
  'api/job/run-step',
  'api/job/inpaint',
  'api/job/text-to-image',
  'api/models/generate',
  'api/pose/import-from-prompt',
];

const PLAN_ERROR_CODE_VALUES: readonly string[] = Object.values(PLAN_ERROR_CODES);

export function isQuotaBlockedRequest(
  url: string,
  errorCode: string | undefined,
): boolean {
  if (!errorCode || !PLAN_ERROR_CODE_VALUES.includes(errorCode)) return false;
  return QUOTA_GATED_PATH_FRAGMENTS.some((fragment) => url.includes(fragment));
}
